// ******************
// Utils.js
// ******************
import moment from "moment";
export function getParameterByName(name) {
    const location = window.location || '';

    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };
export const formatExpiration = (date) => {
    let formatted;
    if(date) {
    formatted = moment(date * 1000).format('MM/DD/YYYY')
    if( moment(formatted).isAfter('12/31/2050')) {
      formatted = moment(date).format('MM/DD/YYYY')
    }
    return formatted;
  } else {
    return null
  }
}
